import React, { useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';
import LedgerTable from './component/Ledger/component/LedgersTable';
import { AuthContext } from '../../../context/AuthContext';




const Account = () => {
  const { agentId } = useContext(AuthContext);
  return (
    <Container>
      
      <LedgerTable agentId={agentId} />
     
    </Container>
    );
};
export default Account;
